<template>
  <tr :class="[{'active': active}, {'selected': selected[item.tempID]}]">
    <td>
      <v-icon 
      @click.stop="$emit('checkRow', item)"
      :color="selected[item.tempID] ? 'color1' : ''"> 
        {{ selected[item.tempID] ? 'check_box' : 'check_box_outline_blank' }}
      </v-icon>
      <v-menu v-if="$store.state.settings.debugMode" offset-x open-on-hover :close-on-content-click="false">
        <template v-slot:activator="{ on }">
          <v-btn
            icon
            small
            color="red"
            v-on="on"
          >
            <v-icon small>mdi-android-debug-bridge</v-icon>
          </v-btn>
        </template>
        <v-card outlined class="elevation-0">
          <v-layout class="backgroundCard pa-2 caption">
            JSON
          </v-layout>
          <div class="c-hr"></div>
          <div class="pa-3">
            <span class="caption">
              {{ item }}
              <json-viewer :item="item"></json-viewer>
            </span>
          </div>
        </v-card>
      </v-menu>

      {{ item.definition.name }}

    </td>
    <td>
      <div
      class="underline-link"
      @click.stop="$root.$timelineNav.open(item.archive_id)">
        RID:
        {{ item.archive_id }}
      </div>
    </td>
    <td>

      <!--
      <c-ms-ii
      :metric_definition="item.definition" 
      :realValue="item.quantity"
      :key="item.id"
      ></c-ms-ii>
      -->

      <!-- NEW -->
      <c-ms-ii
      :metric_definition="item.definition" 
      :realValue.sync="item.quantity"
      :key="'c' + (item.definition || {}).id"
      :class="[error ? 'pink--text' : 'text--text', 'borderless']"
      ref="metricSelector"
      ></c-ms-ii>

      <v-progress-linear
      class="ma-0"
      :value="percent"
      :key="item.inventory_item_id"
      :color="error ? 'pink' : 'color1'"
      background-color="backgroundCard"
      height="5"
      striped
      style="margin-bottom: 1px!important;"
      ></v-progress-linear>

      <v-row class="align-center caption">
        <v-btn icon small @click="useWholeBatch">
          <v-icon small>mdi-chevron-up</v-icon>
        </v-btn>
        <v-btn icon small @click="useNoneOfBatch">
          <v-icon small>mdi-close</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
        
        /&nbsp;
        
        <c-ms-ii
        :metric_definition="item.definition" 
        :realValue="totalAvailable"
        :key="'a' + (item.definition || {}).id"
        alwaysScale
        labelMode
        class="ma-2"
        ></c-ms-ii>

      </v-row>

      <v-row v-if="false" class="caption grey--text align-center">
        <v-col sm="6">
          <div>
            Reserved :
          </div>
          <c-ms-ii
          :metric_definition="item.definition" 
          :realValue="reserved"
          :key="'a' + (item.definition || {}).id"
          alwaysScale
          labelMode
          class=""
          ></c-ms-ii>
        </v-col>
        <v-col sm="6">
          <div>
            Inventory :
          </div>
          <c-ms-ii
          :metric_definition="item.definition" 
          :realValue="totalAvailable - reserved"
          :key="'d' + (item.definition || {}).id"
          alwaysScale
          labelMode
          class="green--text"
          ></c-ms-ii>
        </v-col>
        
      </v-row>
    </td>
  </tr>
</template>

<script>
import JsonViewer from '@/components/toolbox/json-viewer/Main'

export default {
  props: ['item', 'reserved', 'inventoryView', 'mergeMap', 'selected', 'searchFilters', 'active', 'currentSelection'],
  components: {
    JsonViewer
  },
  data () {
    return {
      
    }
  },
  computed: {
    percent () {
      return 100 - (((this.totalAvailable - this.item.quantity) / this.totalAvailable) * 100) || 0
    },
    error () {
      if (this.item.quantity > this.totalAvailable) {
        return true
      }
      return false
    },
    totalAvailable () {
      // either its in the merge map or it has inventory_id defined
      var inv_id = this.mergeMap[this.item.id] || this.item.inventory_id
      var inventory_item = this.inventoryView[this.item.inventory_item_id] || []
      var match = inventory_item.find(item => item.id === inv_id) || {}
      return match.quantity
    }
  },
  methods: {
    useNoneOfBatch () {
      this.item.quantity = 0
    },
    useWholeBatch () {
      this.item.quantity = this.totalAvailable
      this.$nextTick(() => {
        this.$refs.metricSelector.rescale()
      })
    },
  }
}
</script>